import { useState } from "react";

/**
 * Custom hook for managing focus state
 * @returns Object with isFocused state and event handlers
 */
export default function useFocus() {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  return {
    isFocused,
    setIsFocused,
    onFocus,
    onBlur,
  };
}
